export const getSelectedFacetCount = (facets: string | string[]): number =>
  Array.isArray(facets) ? facets.length : 1;
